module.exports = __webpack_public_path__ + "img/logo.1d3a2681.png";